/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Cognito API
 * Bank Relationship Management - Cognito
 * OpenAPI spec version: v1
 */
import type {
  CcsCapStrikesFromDeltaRequestDto,
  CcsCapSwapIndicativeRequestDto,
  CcsCapSwapMtMRequestDto,
  CcsSwapIndicativeRequestDto,
  CcsSwapMtMRequestDto,
  ImpliedVolCalculationRequestDto,
  IrsSwapIndicativeRequestDto,
  IrsSwapMtMRequestDto,
  MtMCalculationRequestDto,
  MtMMtMRequestDto,
  PostApiV1DerivativePricingBatchCcsCapIndicative200,
  PostApiV1DerivativePricingBatchCcsCapMtm200,
  PostApiV1DerivativePricingBatchCcsIndicative200,
  PostApiV1DerivativePricingBatchCcsMtm200,
  PostApiV1DerivativePricingBatchImpliedVol200,
  PostApiV1DerivativePricingBatchIrsIndicative200,
  PostApiV1DerivativePricingBatchIrsMtm200,
  PostApiV1DerivativePricingBatchMtm200,
  PostApiV1DerivativePricingBatchPricing200,
  PostApiV1DerivativePricingBatchSwapMtm200,
  PostApiV1DerivativePricingBatchSwapPricing200,
  PostApiV1DerivativePricingCcsCapIndicative200,
  PostApiV1DerivativePricingCcsCapMtm200,
  PostApiV1DerivativePricingCcsCapStrikesFromDelta200,
  PostApiV1DerivativePricingCcsIndicative200,
  PostApiV1DerivativePricingCcsMtm200,
  PostApiV1DerivativePricingImpliedVol200,
  PostApiV1DerivativePricingIrsIndicative200,
  PostApiV1DerivativePricingIrsMtm200,
  PostApiV1DerivativePricingMtm200,
  PostApiV1DerivativePricingPricing200,
  PostApiV1DerivativePricingSwapMtm200,
  PostApiV1DerivativePricingSwapPricing200,
  SwapCalculationRequestDto,
  SwapMtMCalculationRequestDto
} from '../schemas';

import { customInstance } from '.././mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getDerivativePricing = () => {
/**
 * Executa cálculo de precificação NDF para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch NDF Pricing
 */
const postDerivativePricingBatchPricing = (
    mtMCalculationRequestDto?: MtMCalculationRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchPricing200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchPricing200>(
      {url: `/api/v1/derivative-pricing/batch/pricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mtMCalculationRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de MtM NDF para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch NDF MtM
 */
const postDerivativePricingBatchMtm = (
    mtMMtMRequestDto?: MtMMtMRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchMtm200>(
      {url: `/api/v1/derivative-pricing/batch/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mtMMtMRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de Swap indicativo para múltiplas requisições em paralelo. Envie SwapWithCapCalculationRequestDto para itens com CAP. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch Swap Pricing
 */
const postDerivativePricingBatchSwapPricing = (
    swapCalculationRequestDto?: SwapCalculationRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchSwapPricing200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchSwapPricing200>(
      {url: `/api/v1/derivative-pricing/batch/swap/pricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: swapCalculationRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de MtM de Swap para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch Swap MtM
 */
const postDerivativePricingBatchSwapMtm = (
    swapMtMCalculationRequestDto?: SwapMtMCalculationRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchSwapMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchSwapMtm200>(
      {url: `/api/v1/derivative-pricing/batch/swap/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: swapMtMCalculationRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de volatilidade implícita (NDF/opções) para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch Implied Vol
 */
const postDerivativePricingBatchImpliedVol = (
    impliedVolCalculationRequestDto?: ImpliedVolCalculationRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchImpliedVol200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchImpliedVol200>(
      {url: `/api/v1/derivative-pricing/batch/implied-vol`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: impliedVolCalculationRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de IRS indicativo para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch IRS Indicativo
 */
const postDerivativePricingBatchIrsIndicative = (
    irsSwapIndicativeRequestDto?: IrsSwapIndicativeRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchIrsIndicative200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchIrsIndicative200>(
      {url: `/api/v1/derivative-pricing/batch/irs/indicative`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: irsSwapIndicativeRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de CCS indicativo para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch CCS Indicativo
 */
const postDerivativePricingBatchCcsIndicative = (
    ccsSwapIndicativeRequestDto?: CcsSwapIndicativeRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchCcsIndicative200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchCcsIndicative200>(
      {url: `/api/v1/derivative-pricing/batch/ccs/indicative`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsSwapIndicativeRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de MtM de IRS para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch IRS MtM
 */
const postDerivativePricingBatchIrsMtm = (
    irsSwapMtMRequestDto?: IrsSwapMtMRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchIrsMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchIrsMtm200>(
      {url: `/api/v1/derivative-pricing/batch/irs/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: irsSwapMtMRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de MtM de CCS para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch CCS MtM
 */
const postDerivativePricingBatchCcsMtm = (
    ccsSwapMtMRequestDto?: CcsSwapMtMRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchCcsMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchCcsMtm200>(
      {url: `/api/v1/derivative-pricing/batch/ccs/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsSwapMtMRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de CCS CAP indicativo para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch CCS CAP Indicativo
 */
const postDerivativePricingBatchCcsCapIndicative = (
    ccsCapSwapIndicativeRequestDto?: CcsCapSwapIndicativeRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchCcsCapIndicative200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchCcsCapIndicative200>(
      {url: `/api/v1/derivative-pricing/batch/ccs-cap/indicative`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsCapSwapIndicativeRequestDto
    },
      options);
    }
  /**
 * Executa cálculo de MtM de CCS CAP para múltiplas requisições em paralelo. Cada item retorna seu índice original, Success e Data ou Error.
 * @summary Batch CCS CAP MtM
 */
const postDerivativePricingBatchCcsCapMtm = (
    ccsCapSwapMtMRequestDto?: CcsCapSwapMtMRequestDto[],
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingBatchCcsCapMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingBatchCcsCapMtm200>(
      {url: `/api/v1/derivative-pricing/batch/ccs-cap/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsCapSwapMtMRequestDto
    },
      options);
    }
  /**
 * Calcula o preço/prêmio de NDF Vanilla, NDF+CAP, Call/Put Vanilla, Call/Put Spread,
Straddle, Strangle, Collar e Fence. Usa curvas Cognito bmf-curves/{di, dollar, euro}
e superfície de vol B3 para pricing de opções (smile vol-by-strike, Garman-Kohlhagen).

**Tipos de produto:**
1=NDFVanilla, 2=NDFCAP, 3=CallSpread, 4=CallVanilla, 5=PutVanilla,
6=PutSpread, 7=Straddle, 8=Strangle, 9=Collar, 10=Fence

**Parâmetros Obrigatórios:**
- `maturityDate`: Data de vencimento (yyyy-MM-dd)
- `productType`: Tipo de produto (1–10)
- `currency`: USD ou EUR

**Parâmetros de Override (Opcionais):**
- `dataBase`: Data base (yyyy-MM-dd); omitir = usa curva BMF do último dia útil
- `cambio`: Substitui a PTAX D-1 (spot). Afeta forward e GK.
- `carryRateOverride`: Substitui rate360 da curva bmf-curves/{dollar,euro} em % a.a.
- `preRateOverride`: Substitui rate252 da bmf-curves/di em % a.a. (r_d no GK)
- `volatilityOverride`: Vol global em % a.a. para todas as pernas de opções
- `volatilityOverrideStrike1`…`Strike4`: Vol por perna (prevalece sobre global)

**Exemplo NDF Vanilla (USD):**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 1,
  "currency": "USD",
  "dataBase": "2025-01-15"
}
```

**Exemplo NDF+CAP com overrides:**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 2,
  "currency": "USD",
  "dataBase": "2025-01-15",
  "strike": 5.45,
  "cambio": 5.75,
  "carryRateOverride": 5.5,
  "volatilityOverride": 15.0
}
```

**Exemplo Call Spread:**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 3,
  "currency": "USD",
  "dataBase": "2025-01-15",
  "strike": 5.40,
  "strike2": 5.50
}
```

**Exemplo Fence (EUR):**
```json
{
  "maturityDate": "2026-09-03",
  "productType": 10,
  "currency": "EUR",
  "dataBase": "2026-03-04",
  "strike": 5.20,
  "strike2": 5.40,
  "strike3": 5.80
}
```
 * @summary Precificação de NDF e opções FX (tipos 1–10).
 */
const postDerivativePricingPricing = (
    mtMCalculationRequestDto?: MtMCalculationRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingPricing200>>,) => {
      return customInstance<PostApiV1DerivativePricingPricing200>(
      {url: `/api/v1/derivative-pricing/pricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mtMCalculationRequestDto
    },
      options);
    }
  /**
 * Calcula o MtM (Mark-to-Market) de NDF e estruturas de opções a partir da taxa/prêmio contratado e do mercado atual.

**Parâmetros Obrigatórios:**
- maturityDate: Data de vencimento (formato: yyyy-MM-dd)
- productType: Tipo de produto (1=NDFVanilla, 2=NDFCAP, 3=CallSpread, 4=CallVanilla, 5=PutVanilla,
  6=PutSpread, 7=Straddle, 8=Strangle, 9=Collar, 10=Fence)
- currency: Moeda (USD ou EUR)
- tradeRate: Taxa/prêmio negociado na operação
- notional: Valor nocional

**Parâmetros Opcionais:**
- dataBase: Data base (yyyy-MM-dd); omitir = usa curva BMF do último dia útil
- tradeDate: Data de negociação (yyyy-MM-dd)

**Parâmetros de Override (Opcionais):**
- spotOverride: Substitui PTAX D-1 (spot). Python: `cambio`
- carryRateOverride: Substitui rate360 da curva bmf-curves/{dollar,euro} em % a.a. Python: `carry_rate_override`
- preRateOverride: Substitui rate252 da bmf-curves/di em % a.a. Python: `pre_rate_override`
- volatilityOverride: Substitui vol global da superfície B3 em % a.a.
- volatilityOverrideStrike1…Strike4: Vol por perna (prevalece sobre global)

**Observações:**
- Se os overrides não forem informados, o sistema busca automaticamente os valores de mercado via Cognito
- O MtM compara a taxa/prêmio contratado (tradeRate) com o valor de mercado atual para calcular o ganho/perda

**Exemplo para NDF Vanilla (MtM):**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 1,
  "currency": "USD",
  "dataBase": "2025-02-20",
  "tradeDate": "2025-01-15",
  "tradeRate": 5.42,
  "notional": 1000000
}
```

**Exemplo para NDF + Call (CAP) (MtM) com overrides:**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 2,
  "currency": "USD",
  "dataBase": "2025-02-20",
  "tradeDate": "2025-01-15",
  "tradeRate": 5.38,
  "notional": 1000000,
  "strike": 5.45,
  "spotOverride": 5.75,
  "carryRateOverride": 5.5,
  "volatilityOverride": 15.0
}
```

**Exemplo para Call Spread (MtM):**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 3,
  "currency": "USD",
  "dataBase": "2025-02-20",
  "tradeDate": "2025-01-15",
  "tradeRate": 5.30,
  "notional": 1000000,
  "strike": 5.40,
  "strike2": 5.50
}
```

**Exemplo para Call Vanilla (MtM):**
```json
{
  "maturityDate": "2025-09-26",
  "productType": 4,
  "currency": "USD",
  "dataBase": "2025-02-20",
  "tradeDate": "2025-01-15",
  "tradeRate": 0.45,
  "notional": 1000000,
  "strike": 5.45
}
```
 * @summary Mark-to-market de NDF e opções (tipos 1–10) via NdfCallMtMCalculatorService.
 */
const postDerivativePricingMtm = (
    mtMMtMRequestDto?: MtMMtMRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingMtm200>(
      {url: `/api/v1/derivative-pricing/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mtMMtMRequestDto
    },
      options);
    }
  /**
 * Calcula a volatilidade implícita de um derivativo dado um prêmio observado.
Suporta tipos 2–10: NDFCAP, CallSpread, CallVanilla, PutVanilla, PutSpread,
Straddle, Strangle, Collar, Fence.

**Tipos monotônicos** (Straddle=7, Strangle=8, Call/Put Vanilla, Call/Put Spread):
- Usa método de Brent direto no intervalo [1e-6, 5.0].

**Tipos não-monotônicos** (Collar=9, Fence=10):
- Localiza pico e vale da função preço via golden-section, depois aplica Brent por bracketing.
- Retorna o menor σ encontrado (ramo de menor vol).

**Parâmetros obrigatórios:**
- maturityDate: Data de vencimento (yyyy-MM-dd)
- productType: Tipo de produto (2=NDFCAP, 3=CallSpread, 4=CallVanilla, 5=PutVanilla,
  6=PutSpread, 7=Straddle, 8=Strangle, 9=Collar, 10=Fence)
- currency: Moeda (USD ou EUR)
- notional: Valor nocional (padrão: 1.000.000)
- unitPremium OR totalPremium: Prêmio observado (exceto NDFCAP — usa tradeRate). Python: `premio_unitario` / `premio_total`

**Exemplo Straddle:**
```json
{
  "maturityDate": "2026-09-03",
  "productType": 7,
  "currency": "USD",
  "dataBase": "2026-03-04",
  "strike": 5.40,
  "notional": 1000000,
  "unitPremium": 0.18
}
```

**Exemplo Collar:**
```json
{
  "maturityDate": "2026-09-03",
  "productType": 9,
  "currency": "USD",
  "dataBase": "2026-03-04",
  "strike": 5.20,
  "strike2": 5.80,
  "notional": 1000000,
  "unitPremium": 0.03
}
```

**Exemplo Fence:**
```json
{
  "maturityDate": "2026-09-03",
  "productType": 10,
  "currency": "USD",
  "dataBase": "2026-03-04",
  "strike": 5.20,
  "strike2": 5.40,
  "strike3": 5.80,
  "notional": 1000000,
  "totalPremium": 50000
}
```
 * @summary Volatilidade implícita de NDF/opções (tipos 1–10) via NdfCallMtMCalculatorService.
 */
const postDerivativePricingImpliedVol = (
    impliedVolCalculationRequestDto?: ImpliedVolCalculationRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingImpliedVol200>>,) => {
      return customInstance<PostApiV1DerivativePricingImpliedVol200>(
      {url: `/api/v1/derivative-pricing/implied-vol`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: impliedVolCalculationRequestDto
    },
      options);
    }
  /**
 * Calcula o swap indicativo (perna ativa FX, passiva BRL via capital de giro) via SwapCalculatorService.

**Parâmetros Obrigatórios:**
- currency: Moeda do swap ("USD" ou "EUR")
- dataBase: Data base para cálculo (formato: yyyy-MM-dd)
- taxaDivida: Taxa de juros da dívida em moeda estrangeira (em decimal, ex: 0.055 para 5.5%)
- valorTomado: Valor principal tomado em moeda estrangeira
- amortizacoes: Lista de valores de amortização para cada parcela
- datasVenc: Lista de datas de vencimento para cada parcela (formato: yyyy-MM-dd)

**Parâmetros de Override (Opcionais):**

Para SWAP Vanilla:
- ptaxOverride: Substitui a PTAX D-1 (ex: 5.75 para R$ 5,75)
- carryRateOverride: Substitui rate360 da curva bmf-curves/{dollar,euro} em % a.a. Python: `carry_rate_override`
- spreadUsdEurOverride: Override legado do SDE em % (apenas EUR; descontinuado no motor de referência Python)

Para SWAP com CAP (adicional):
- strikes: Lista de strikes das calls vendidas (um por parcela)
- volatilityOverride: Substitui a volatilidade da superfície B3 em % (ex: 15.0 para 15%)

**Observações:**
- Se os overrides não forem informados, o sistema busca automaticamente os valores de mercado
- O SWAP calcula a taxa equivalente em BRL (CDI + spread) que torna o valor presente das duas pernas igual
- Para SWAP com CAP, os strikes representam calls vendidas que limitam a exposição cambial

**Exemplo para SWAP Vanilla (USD):**
```json
{
  "currency": "USD",
  "dataBase": "2025-01-15",
  "taxaDivida": 0.055,
  "valorTomado": 1000000,
  "amortizacoes": [250000, 250000, 250000, 250000],
  "datasVenc": ["2025-04-15", "2025-07-15", "2025-10-15", "2026-01-15"]
}
```

**Exemplo para SWAP Vanilla com overrides:**
```json
{
  "currency": "USD",
  "dataBase": "2025-01-15",
  "taxaDivida": 0.055,
  "valorTomado": 1000000,
  "amortizacoes": [250000, 250000, 250000, 250000],
  "datasVenc": ["2025-04-15", "2025-07-15", "2025-10-15", "2026-01-15"],
  "ptaxOverride": 5.75,
  "carryRateOverride": 5.5
}
```

**Exemplo para SWAP com CAP (USD):**
```json
{
  "currency": "USD",
  "dataBase": "2025-01-15",
  "taxaDivida": 0.055,
  "valorTomado": 1000000,
  "amortizacoes": [250000, 250000, 250000, 250000],
  "datasVenc": ["2025-04-15", "2025-07-15", "2025-10-15", "2026-01-15"],
  "strikes": [5.45, 5.50, 5.55, 5.60],
  "volatilityOverride": 15.0
}
```

**Exemplo para SWAP Vanilla (EUR):**
```json
{
  "currency": "EUR",
  "dataBase": "2025-01-15",
  "taxaDivida": 0.035,
  "valorTomado": 500000,
  "amortizacoes": [125000, 125000, 125000, 125000],
  "datasVenc": ["2025-04-15", "2025-07-15", "2025-10-15", "2026-01-15"],
  "spreadUsdEurOverride": 2.5
}
```
 * @summary Precificação indicativa de SWAP (fluxo FX→BRL) via SwapCalculatorService.
 */
const postDerivativePricingSwapPricing = (
    swapCalculationRequestDto?: SwapCalculationRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingSwapPricing200>>,) => {
      return customInstance<PostApiV1DerivativePricingSwapPricing200>(
      {url: `/api/v1/derivative-pricing/swap/pricing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: swapCalculationRequestDto
    },
      options);
    }
  /**
 * Calcula o MtM de swap no fluxo novo (perna ativa FX, passiva BRL via capital de giro; cap opcional) via SwapCalculatorService.

**Contrato alinhado ao Python:**
- activeCurrency: moeda da ponta ativa (`USD` ou `EUR`)
- passiveCurrency: moeda da ponta passiva (`BRL`)
- baseDate: data base do cálculo
- contractDate: data de contratação
- activeRate: taxa anual da ponta ativa em %
- passiveRate: taxa anual da ponta passiva em %
- contractExchangeRate: câmbio de contratação
- activeNotional: notional da ponta ativa
- activeLegFlow: fluxo ativo informado pelo usuário
- strikes: opcional, um por parcela do fluxo ativo

**Importante:**
- este é o único contrato suportado para MTM de swap no backend
- ele cobre o escopo hoje implementado no Python para FX/BRL
- no contrato novo o fluxo passivo é gerado internamente via capital de giro personalizado e a PTAX usada é a exata da `baseDate`
- os dias úteis do swap novo seguem exatamente o Python atual: apenas segunda a sexta, sem feriados
- a rotina de geração diária de MTM usa o mesmo caminho de cálculo

**Exemplo para SWAP MtM novo fluxo (sem cap):**
```json
{
  "activeCurrency": "USD",
  "passiveCurrency": "BRL",
  "baseDate": "2026-04-02",
  "contractDate": "2026-03-10",
  "activeRate": 12.75,
  "passiveRate": 15.10,
  "contractExchangeRate": 5.72,
  "activeNotional": 1000000,
  "activeLegFlow": [
    { "installmentsNumber": 1, "dueAt": "2026-06-30", "amortizationValue": 300000 },
    { "installmentsNumber": 2, "dueAt": "2026-09-30", "amortizationValue": 300000 },
    { "installmentsNumber": 3, "dueAt": "2026-12-31", "amortizationValue": 400000 }
  ]
}
```

**Exemplo para SWAP MtM novo fluxo com cap:**
```json
{
  "activeCurrency": "USD",
  "passiveCurrency": "BRL",
  "baseDate": "2026-04-02",
  "contractDate": "2026-03-10",
  "activeRate": 12.75,
  "passiveRate": 15.10,
  "contractExchangeRate": 5.72,
  "activeNotional": 1000000,
  "activeLegFlow": [
    { "installmentsNumber": 1, "dueAt": "2026-06-30", "amortizationValue": 300000 },
    { "installmentsNumber": 2, "dueAt": "2026-09-30", "amortizationValue": 300000 },
    { "installmentsNumber": 3, "dueAt": "2026-12-31", "amortizationValue": 400000 }
  ],
  "strikes": [5.85, 5.92, 5.98]
}
```
 * @summary Mark-to-market de SWAP (fluxo FX→BRL, com/sem cap) via SwapCalculatorService.
 */
const postDerivativePricingSwapMtm = (
    swapMtMCalculationRequestDto?: SwapMtMCalculationRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingSwapMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingSwapMtm200>(
      {url: `/api/v1/derivative-pricing/swap/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: swapMtMCalculationRequestDto
    },
      options);
    }
  /**
 * BRL: composto 252 du. USD/EUR: simples 360 dc.
Indexadores BRL: CDI | PRE | IPCA+. USD: SOFR | PRE. EUR: EURIBOR | PRE.

**Exemplo BRL CDI/PRE:**
```json
{
  "moeda": "BRL",
  "notional": 10000000,
  "indexadorAtivo": "CDI",
  "spreadAtivoPct": 2.5,
  "indexadorPassivo": "PRE",
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50 },
    { "dataVencimento": "31/12/2026", "amortPct": 50 }
  ]
}
```

**Exemplo USD PRE/SOFR:**
```json
{
  "moeda": "USD",
  "notional": 1000000,
  "indexadorAtivo": "PRE",
  "spreadAtivoPct": 5.5,
  "indexadorPassivo": "SOFR",
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50 },
    { "dataVencimento": "31/12/2026", "amortPct": 50 }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/irs/indicative" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moeda":"BRL","notional":10000000,"indexadorAtivo":"CDI","spreadAtivoPct":2.5,"indexadorPassivo":"PRE","schedule":[{"dataVencimento":"30/06/2026","amortPct":50},{"dataVencimento":"31/12/2026","amortPct":50}]}'
```
 * @summary IRS Indicativo: calcula taxa par da perna passiva (moeda única).
 */
const postDerivativePricingIrsIndicative = (
    irsSwapIndicativeRequestDto?: IrsSwapIndicativeRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingIrsIndicative200>>,) => {
      return customInstance<PostApiV1DerivativePricingIrsIndicative200>(
      {url: `/api/v1/derivative-pricing/irs/indicative`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: irsSwapIndicativeRequestDto
    },
      options);
    }
  /**
 * PV ativo convertido em moeda passiva via PTAX D-1.

**Exemplo USD ativa / BRL passiva CDI:**
```json
{
  "moedaAtiva": "USD",
  "moedaPassiva": "BRL",
  "notionalAtivo": 1000000,
  "indexadorAtivo": "PRE",
  "spreadAtivoPct": 5.5,
  "indexadorPassivo": "CDI",
  "spreadPassivoPct": 0,
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50 },
    { "dataVencimento": "31/12/2026", "amortPct": 50 }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/ccs/indicative" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moedaAtiva":"USD","moedaPassiva":"BRL","notionalAtivo":1000000,"indexadorAtivo":"PRE","spreadAtivoPct":5.5,"indexadorPassivo":"CDI","spreadPassivoPct":0,"schedule":[{"dataVencimento":"30/06/2026","amortPct":50},{"dataVencimento":"31/12/2026","amortPct":50}]}'
```
 * @summary CCS Indicativo: calcula taxa par da perna passiva (moedas distintas).
 */
const postDerivativePricingCcsIndicative = (
    ccsSwapIndicativeRequestDto?: CcsSwapIndicativeRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingCcsIndicative200>>,) => {
      return customInstance<PostApiV1DerivativePricingCcsIndicative200>(
      {url: `/api/v1/derivative-pricing/ccs/indicative`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsSwapIndicativeRequestDto
    },
      options);
    }
  /**
 * MtM = PV_ativo − PV_passivo. Suporta período corrente via dataInicioPeriodo + fatorAcumulado.

**Exemplo BRL CDI/PRE com período corrente:**
```json
{
  "moeda": "BRL",
  "notional": 10000000,
  "indexadorAtivo": "CDI",
  "spreadAtivoPct": 2.5,
  "indexadorPassivo": "PRE",
  "spreadPassivoPct": 14.5,
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50, "dataInicioPeriodo": "02/01/2026" },
    { "dataVencimento": "31/12/2026", "amortPct": 50, "dataInicioPeriodo": "30/06/2026" }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/irs/mtm" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moeda":"BRL","notional":10000000,"indexadorAtivo":"CDI","spreadAtivoPct":2.5,"indexadorPassivo":"PRE","spreadPassivoPct":14.5,"schedule":[{"dataVencimento":"30/06/2026","amortPct":50,"dataInicioPeriodo":"02/01/2026"},{"dataVencimento":"31/12/2026","amortPct":50,"dataInicioPeriodo":"30/06/2026"}]}'
```
 * @summary IRS MtM: mark-to-market com taxas/spreads contratados nas duas pernas.
 */
const postDerivativePricingIrsMtm = (
    irsSwapMtMRequestDto?: IrsSwapMtMRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingIrsMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingIrsMtm200>(
      {url: `/api/v1/derivative-pricing/irs/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: irsSwapMtMRequestDto
    },
      options);
    }
  /**
 * MtM_cupons = PV_ativo_em_passiva − PV_passiva.
Quando `includePrincipalExchange=true`, soma a troca de principal marcada a spot atual:
principal_spot = notionalAtivo × spotAtual − notionalPassivo.
Par implícita calculada automaticamente com a mesma opção de principal.

**Exemplo USD/BRL MtM:**
```json
{
  "moedaAtiva": "USD",
  "moedaPassiva": "BRL",
  "notionalAtivo": 1000000,
  "indexadorAtivo": "PRE",
  "spreadAtivoPct": 5.5,
  "indexadorPassivo": "CDI",
  "spreadPassivoPct": 2.5,
  "includePrincipalExchange": true,
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50, "dataInicioPeriodo": "02/01/2026" },
    { "dataVencimento": "31/12/2026", "amortPct": 50, "dataInicioPeriodo": "30/06/2026" }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/ccs/mtm" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moedaAtiva":"USD","moedaPassiva":"BRL","notionalAtivo":1000000,"indexadorAtivo":"PRE","spreadAtivoPct":5.5,"indexadorPassivo":"CDI","spreadPassivoPct":2.5,"schedule":[{"dataVencimento":"30/06/2026","amortPct":50,"dataInicioPeriodo":"02/01/2026"},{"dataVencimento":"31/12/2026","amortPct":50,"dataInicioPeriodo":"30/06/2026"}]}'
```
 * @summary CCS MtM: mark-to-market cross-currency com suporte a período corrente.
 */
const postDerivativePricingCcsMtm = (
    ccsSwapMtMRequestDto?: CcsSwapMtMRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingCcsMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingCcsMtm200>(
      {url: `/api/v1/derivative-pricing/ccs/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsSwapMtMRequestDto
    },
      options);
    }
  /**
 * Perna ativa PRE FX; passiva BRL (CDI/PRE/IPCA+). Vol por smile B3 iterativo.
Cada item do schedule DEVE ter strike. NotionalCapFx e volOverride são opcionais.

**Exemplo USD/BRL CDI com caps:**
```json
{
  "moedaAtiva": "USD",
  "notionalAtivo": 1000000,
  "spreadAtivoPct": 5.5,
  "indexadorPassivo": "CDI",
  "spreadPassivoPct": 2.5,
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50, "strike": 6.10 },
    { "dataVencimento": "31/12/2026", "amortPct": 50, "strike": 6.30 }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/ccs-cap/indicative" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moedaAtiva":"USD","notionalAtivo":1000000,"spreadAtivoPct":5.5,"indexadorPassivo":"CDI","spreadPassivoPct":2.5,"schedule":[{"dataVencimento":"30/06/2026","amortPct":50,"strike":6.10},{"dataVencimento":"31/12/2026","amortPct":50,"strike":6.30}]}'
```
 * @summary CCS CAP Indicativo: CCS com call vendida por parcela (USDBRL/EURBRL).
 */
const postDerivativePricingCcsCapIndicative = (
    ccsCapSwapIndicativeRequestDto?: CcsCapSwapIndicativeRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingCcsCapIndicative200>>,) => {
      return customInstance<PostApiV1DerivativePricingCcsCapIndicative200>(
      {url: `/api/v1/derivative-pricing/ccs-cap/indicative`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsCapSwapIndicativeRequestDto
    },
      options);
    }
  /**
 * MtM_total = MtM_ccs_puro + MtM_caps (= -Σ prêmios remanescentes).
No MtM, `MtM_ccs_puro` usa PV de cupons e, quando `includePrincipalExchange=true`,
inclui a troca de principal marcada a spot atual:
principal_spot = notionalAtivo × spotAtual − notionalPassivo.
Suporta período corrente via dataInicioPeriodo + fatorAcumulado.

**Exemplo USD/BRL CDI MtM com caps:**
```json
{
  "moedaAtiva": "USD",
  "notionalAtivo": 1000000,
  "spreadAtivoPct": 5.5,
  "indexadorPassivo": "CDI",
  "spreadPassivoPct": 2.5,
  "includePrincipalExchange": true,
  "schedule": [
    { "dataVencimento": "30/06/2026", "amortPct": 50, "strike": 6.10, "dataInicioPeriodo": "02/01/2026" },
    { "dataVencimento": "31/12/2026", "amortPct": 50, "strike": 6.30, "dataInicioPeriodo": "30/06/2026" }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/ccs-cap/mtm" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moedaAtiva":"USD","notionalAtivo":1000000,"spreadAtivoPct":5.5,"indexadorPassivo":"CDI","spreadPassivoPct":2.5,"schedule":[{"dataVencimento":"30/06/2026","amortPct":50,"strike":6.10,"dataInicioPeriodo":"02/01/2026"},{"dataVencimento":"31/12/2026","amortPct":50,"strike":6.30,"dataInicioPeriodo":"30/06/2026"}]}'
```
 * @summary CCS CAP MtM: mark-to-market de CCS com cap por parcela.
 */
const postDerivativePricingCcsCapMtm = (
    ccsCapSwapMtMRequestDto?: CcsCapSwapMtMRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingCcsCapMtm200>>,) => {
      return customInstance<PostApiV1DerivativePricingCcsCapMtm200>(
      {url: `/api/v1/derivative-pricing/ccs-cap/mtm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsCapSwapMtMRequestDto
    },
      options);
    }
  /**
 * Helper que converte um delta-call alvo em lista de strikes por parcela.
Para cada vencimento do schedule, calcula:
- vol B3 no delta-alvo (interpolada na smile);
- inversa do delta-call do Garman-Kohlhagen com essa vol;
- strike resultante.

Não roda PV de swap nem solver de spread.
Os strikes retornados alimentam `schedule[*].strike` de `/ccs-cap/indicative`.
Convenção: delta = spot call delta em percent (1–99, 50 = ATM forward).
Para cap de proteção típica em USDBRL (call OTM, K > Forward), use delta baixo (10–25).

```json
{
  "moeda": "USD",
  "deltaCallPct": 25,
  "schedule": [
    { "dataVencimento": "15/06/2026" },
    { "dataVencimento": "15/12/2026" }
  ]
}
```

```bash
curl -X POST "{host}/api/v1/derivative-pricing/ccs-cap/strikes-from-delta" \
  -H "Content-Type: application/json" -H "Authorization: Bearer {token}" \
  -d '{"moeda":"USD","deltaCallPct":25,"schedule":[{"dataVencimento":"15/06/2026"},{"dataVencimento":"15/12/2026"}]}'
```
 * @summary Helper: converte delta-call alvo em lista de strikes por parcela de CCS CAP.
 */
const postDerivativePricingCcsCapStrikesFromDelta = (
    ccsCapStrikesFromDeltaRequestDto?: CcsCapStrikesFromDeltaRequestDto,
 options?: SecondParameter<typeof customInstance<PostApiV1DerivativePricingCcsCapStrikesFromDelta200>>,) => {
      return customInstance<PostApiV1DerivativePricingCcsCapStrikesFromDelta200>(
      {url: `/api/v1/derivative-pricing/ccs-cap/strikes-from-delta`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ccsCapStrikesFromDeltaRequestDto
    },
      options);
    }
  return {postDerivativePricingBatchPricing,postDerivativePricingBatchMtm,postDerivativePricingBatchSwapPricing,postDerivativePricingBatchSwapMtm,postDerivativePricingBatchImpliedVol,postDerivativePricingBatchIrsIndicative,postDerivativePricingBatchCcsIndicative,postDerivativePricingBatchIrsMtm,postDerivativePricingBatchCcsMtm,postDerivativePricingBatchCcsCapIndicative,postDerivativePricingBatchCcsCapMtm,postDerivativePricingPricing,postDerivativePricingMtm,postDerivativePricingImpliedVol,postDerivativePricingSwapPricing,postDerivativePricingSwapMtm,postDerivativePricingIrsIndicative,postDerivativePricingCcsIndicative,postDerivativePricingIrsMtm,postDerivativePricingCcsMtm,postDerivativePricingCcsCapIndicative,postDerivativePricingCcsCapMtm,postDerivativePricingCcsCapStrikesFromDelta}};
export type PostApiV1DerivativePricingBatchPricingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchPricing']>>>
export type PostApiV1DerivativePricingBatchMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchMtm']>>>
export type PostApiV1DerivativePricingBatchSwapPricingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchSwapPricing']>>>
export type PostApiV1DerivativePricingBatchSwapMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchSwapMtm']>>>
export type PostApiV1DerivativePricingBatchImpliedVolResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchImpliedVol']>>>
export type PostApiV1DerivativePricingBatchIrsIndicativeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchIrsIndicative']>>>
export type PostApiV1DerivativePricingBatchCcsIndicativeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchCcsIndicative']>>>
export type PostApiV1DerivativePricingBatchIrsMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchIrsMtm']>>>
export type PostApiV1DerivativePricingBatchCcsMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchCcsMtm']>>>
export type PostApiV1DerivativePricingBatchCcsCapIndicativeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchCcsCapIndicative']>>>
export type PostApiV1DerivativePricingBatchCcsCapMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingBatchCcsCapMtm']>>>
export type PostApiV1DerivativePricingPricingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingPricing']>>>
export type PostApiV1DerivativePricingMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingMtm']>>>
export type PostApiV1DerivativePricingImpliedVolResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingImpliedVol']>>>
export type PostApiV1DerivativePricingSwapPricingResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingSwapPricing']>>>
export type PostApiV1DerivativePricingSwapMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingSwapMtm']>>>
export type PostApiV1DerivativePricingIrsIndicativeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingIrsIndicative']>>>
export type PostApiV1DerivativePricingCcsIndicativeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingCcsIndicative']>>>
export type PostApiV1DerivativePricingIrsMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingIrsMtm']>>>
export type PostApiV1DerivativePricingCcsMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingCcsMtm']>>>
export type PostApiV1DerivativePricingCcsCapIndicativeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingCcsCapIndicative']>>>
export type PostApiV1DerivativePricingCcsCapMtmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingCcsCapMtm']>>>
export type PostApiV1DerivativePricingCcsCapStrikesFromDeltaResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getDerivativePricing>['postDerivativePricingCcsCapStrikesFromDelta']>>>
